import axios from "axios";

import { message } from "antd";
import { API_URL, IMAGE_BASE_URL } from "../constants/api";
import {
  ERROR_INTERNET_CONNECTIVITY,
  ERROR_MESSAGE_404,
  ERROR_MESSAGE_500,
} from "../constants/messages";
import {
  ERROR_MSG_TYPE,
  INFO_MSG_TYPE,
  SUCCESS_MSG_TYPE,
  WARNING_MSG_TYPE,
} from "../constants/messages";
import LS_SERVICE from "./localStorage";

export const makeURL = function (URL) {
  return API_URL + "/" + URL;
};
export const makeFileURL = function (URL) {
  return IMAGE_BASE_URL + "/" + URL;
};
export const putAPI = function (
  URL,
  data,
  successFn,
  errorFn,
  headerConfig = {}
) {
  axios({
    method: "put",
    url: makeURL(URL),
    data: data,
    headers: {
      Authorization: "Bearer " + getAuthToken(),
      ...headerConfig,
    },
  })
    .then(function (response) {
      let data = response.data;
      successFn(data);
    })
    .catch(function (error) {
      handleErrorResponse(error);
      errorFn(data);
    });
};

export const exPostAPI = function (
  URL,
  data,
  successFn,
  errorFn,
  headerConfig = {}
) {
  axios({
    method: "post",
    url: URL,
    data: data,
    headers: {
      Authorization: "Bearer " + getAuthToken(),
      ...headerConfig,
    },
  })
    .then(function (response) {
      let reData = response.data;
      successFn(reData);
    })
    .catch(function (error) {
      handleErrorResponse(error);
      errorFn();
    });
};

export const postAPI = function (
  URL,
  data,
  successFn,
  errorFn,
  headerConfig = {}
) {
  axios({
    method: "post",
    url: makeURL(URL),
    data: data,
    headers: {
      Authorization: "Bearer " + getAuthToken(),
      ...headerConfig,
    },
  })
    .then(function (response) {
      let data = response.data;
      successFn(data);
    })
    .catch(function (error) {
      handleErrorResponse(error);
      errorFn();
    });
};

export const getAPI = function (URL, successFn, errorFn, params = {}) {
  axios({
    method: "get",
    url: makeURL(URL),
    headers: {
      Authorization: "Bearer " + getAuthToken(),
    },
    params: params,
  })
    .then(function (response) {
      let data = response.data;
      successFn(data);
    })
    .catch(function (error) {
      handleErrorResponse(error);
      errorFn();
    });
};
export const deleteAPI = function (URL, successFn, errorFn) {
  axios({
    method: "delete",
    url: makeURL(URL),
    headers: {
      Authorization: "Bearer " + getAuthToken(),
    },
  })
    .then(function (response) {
      let data = response.data;
      successFn(data);
    })
    .catch(function (error) {
      handleErrorResponse(error);
      errorFn();
    });
};

export const handleErrorResponse = function (error) {
  let response = error.response;
  if (response) {
    console.info("Error Response Received", response);
    let status = response.status;
    if (status === 401) {
      LS_SERVICE.login_clear();
      window.location.reload();
    } else if (status === 400) {
      if (response.data.message) {
        message.error(response.data.message);
      }
    } else if (status === 404) {
      if (response.data.message) {
        message.error(response.data.message);
      } else {
        message.error(ERROR_MESSAGE_404);
      }
    } else if (status === 500) {
      message.error(ERROR_MESSAGE_500);
    } else {
      message.error(response.data.message);
    }
  } else {
    message.error(ERROR_INTERNET_CONNECTIVITY);
    console.error(response);
  }
};

export const interpolate = function (theString, argumentArray) {
  var regex = /%s/;
  var _r = function (p, c) {
    return p.replace(regex, c);
  };
  return argumentArray.reduce(_r, theString);
};

export const displayMessage = function (type, msg) {
  if (type === SUCCESS_MSG_TYPE) message.success(msg);
  else if (type === INFO_MSG_TYPE) message.info(msg);
  else if (type === WARNING_MSG_TYPE) message.warning(msg);
  else if (type === ERROR_MSG_TYPE) message.error(msg);
};

export const startLoadingMessage = function (msg) {
  return message.loading(msg, 0);
};
export const stopLoadingMessage = function (msgFn, finishMsgType, finishMsg) {
  msgFn();
  if (finishMsgType) displayMessage(finishMsgType, finishMsg);
  return true;
};
export const stripHTML = function (html) {
  var tmp = document.createElement("DIV");
  tmp.innerHTML = html;
  return tmp.textContent || tmp.innerText || "";
};

export const getAuthToken = () => {
  return LS_SERVICE.get("token") || "";
};

// Function to generate slug from the title
export const generateSlug = (title) => {
  return title
    .toLowerCase() // Convert to lowercase
    .trim() // Trim whitespace
    .replace(/[^a-z0-9\s-]/g, "") // Remove special characters
    .replace(/\s+/g, "-") // Replace spaces with hyphens
    .replace(/-+/g, "-"); // Replace multiple hyphens with a single one
};

export const generateRandomColor = () => {
  // Generate a random color, avoiding white and black by limiting the range
  const randomColor = Math.floor(Math.random() * 0xc0c0c0) + 0x333333; // Avoid extreme white/black

  return "#" + randomColor.toString(16);
};

export const primaryLightenColor = () => {
  const hex = LS_SERVICE.get("setting")["theme"];
  const factor = 0.2;
  let r = parseInt(hex.substring(0, 2), 16);
  let g = parseInt(hex.substring(2, 4), 16);
  let b = parseInt(hex.substring(4, 6), 16);

  r = Math.min(255, Math.floor(r + (255 - r) * factor));
  g = Math.min(255, Math.floor(g + (255 - g) * factor));
  b = Math.min(255, Math.floor(b + (255 - b) * factor));

  return `#${((1 << 24) | (r << 16) | (g << 8) | b).toString(16).slice(1)}`;
};
